<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'customers'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/sales/customer/_new",
       tableColumns: [
              {
                prop: 'code',
                label: 'CODE',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'name',
                label: 'NAME',
                minWidth: 180,
                sortable: true,
                key:'NAME'
              },

              {
                prop: 'contact_email',
                label: 'EMAIL',
                minWidth: 180,
                sortable: true,
                key:'EMAIL'
              },
              {
                prop: 'contact_telephone',
                label: ' TELEPHONE',
                minWidth: 120,
                sortable: true,
                key:'TELEPHONE'
              },
              {
                prop: 'customer_credit_limit',
                label: 'CREDIT_LIMIT',
                minWidth: 140,
                sortable: true,
                key:'CREDIT_LIMIT'
              },
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            },

        }

  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>